<template>
  <div class="tag-wrap">
    <div class="tag-list">
			<h3>{{$t('adminTags.list')}}</h3>
      <div v-for="(tag, i) in tags" :key="i" class="single-tag">
        <span @click="selectTag(tag)">{{ tag.tag_name }}</span>
				<span class="material-icons" @click='deleteTag(tag)'>
					close
				</span>
      </div>
    </div>
    <div class="modify-tag">
			<div class="add-tag">
				<h3>{{$t('adminTags.createTagTitle')}}</h3>
				<input type="text" v-model="tag_name" @keydown.enter='createTag(tag_name)'/>
				<br>
				<button class="button-round" @click="createTag(tag_name)"> {{$t('adminTags.createTag')}} </button>
			</div>
			<br>
			<div class="change-tag" v-if="tagEdit">
				<h3>{{$t('adminTags.changeTagTitle')}}</h3>
				<input type="text" v-model="tagEdit.tag_name" @keydown.enter='changeTag' />
				<br>
				<button class="button-round" @click="changeTag"> {{$t('adminTags.changeTag')}} </button>
			</div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      tags: [],
			tag_name: '',
			tagEdit: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
			this.startLoading()
      let res;
      try {
        res = await api.getTags();
        console.log(res.data);
        this.tags = res.data.result;
      } catch (e) {
        console.warn(e);
      }
			this.stopLoading();
    },
		selectTag (tag) {
			this.tagEdit = JSON.parse(JSON.stringify(tag));
		},
		async changeTag () {
			let obj = {
				tag_name: this.tagEdit.tag_name,
				tag_id: this.tagEdit.tag_id
			}
			console.log(obj);
			try {
				let res = await api.patchTag(obj);
				console.log(res.data);
				this.openToast(this.$t('adminTags.changeTagOk'))
				this.init()
				this.tagEdit = null;
			} catch (error) {
				console.warn(error);
				this.customError(this.$t('adminTags.fail'))
			}
		},
		async createTag(name) {
			if (!name) return;
			try {
				let res = await api.postTag({
					tag_name: name
				});
				console.log(res.data);
				this.openToast(this.$t('adminTags.createOk'))
				this.init()
				this.tag_name = ''
			} catch (error) {
				console.warn(error);
				this.customError(this.$t('adminTags.fail'))
			}
		},
		deleteTag(tag) {
			const confirmProp = {
				title: this.$t('adminTags.delete', {name: tag.tag_name}),
				okCallback: async () => {
					try {
						let res = await api.deleteTag({
							tag_id: tag.tag_id
						})
						console.log(res.data)
						this.openToast(this.$t('adminTags.deleteOk'));
						this.init()
					} catch (error) {
						console.warn(error);
						this.customError(this.$t('adminTags.fail'))	
					}
				}
			}
			this.EventBus.$emit("confirm", confirmProp);
		},
  },
};
</script>

<style scoped lang='scss'>
.tag-wrap {
  padding: 40px 0;
  display: flex;
}
.tag-list {
  width: 20%;
	.single-tag {
		height: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		&:hover {
			opacity: 1;
			.material-icons {
				opacity: 1;
			}
		}
		.material-icons {
			transition: all 0.1s ease-in-out;
			opacity: 0;
		}
		span {
			cursor: pointer;
		}
	}
}
.modify-tag {
	margin-left: 30px;
  width: 40%;
}
</style>